import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './order-after-sales.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { OrderAfterSales } from "model/procure/order-after-sales.model";

export interface OrderAfterSalesDetailsProps extends DetailsStateAndDispatchProps<OrderAfterSales>,
  RouteComponentProps, StateProps, DispatchProps {
}
const OrderAfterSalesDetails: FC<OrderAfterSalesDetailsProps> = (props) => {
  return (
    <DetailsPage<OrderAfterSales>
      title={'售后退款原因'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<OrderAfterSales>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ orderAfterSales }: RootState) => ({
  entity: orderAfterSales.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(OrderAfterSalesDetails);
